import { TimeAllocationType } from '../work-periods-client/work-periods-client.type';

enum TargetComparison {
  LT = 'lt',
  LTE = 'lte',
  EQ = 'eq',
  GTE = 'gte',
  GT = 'gt',
  RANGE_IN = 'range_in',
  RANGE_EX = 'range_ex',
}

type Relationship = {
  id: string;
  name: string;
  start_date?: string;
  end_date?: string;
};

type Target = {
  id: string;
  organization: string;
  name: string | null;
  start_date: string;
  end_date: string | null;
  time_allocation_type: TimeAllocationType | null;
  is_active: boolean;
  use_transform: boolean;
  measure: string;
  target_value: number;
  target_value_upper: number | null;
  target_comparison: TargetComparison;
  is_work_period_target: boolean;
  green_threshold_lower: number | null;
  green_threshold_upper: number | null;
  yellow_threshold_lower: number | null;
  yellow_threshold_upper: number | null;
  red_threshold_lower: number | null;
  red_threshold_upper: number | null;
  portfolios: Relationship[];
  projects: Relationship[];
  subprojects: Relationship[];
  initiatives: Relationship[];
};

type TargetPayload = Omit<Target, 'portfolios' | 'projects' | 'subprojects' | 'initiatives'> & {
  portfolios: string[];
  projects: string[];
  subprojects: string[];
  initiatives: string[];
};

type TransformedTargetThreshold = {
  green_threshold_lower: number | null;
  green_threshold_upper: number | null;
  yellow_threshold_lower: number | null;
  yellow_threshold_upper: number | null;
  red_threshold_lower: number | null;
  red_threshold_upper: number | null;
};

type TransformedTarget = {
  id: string;
  name: string | null;
  measure: string;
  start_date: string;
  end_date: string | null;
  use_transform: boolean;
  is_work_period_target: boolean;
  target_comparison: TargetComparison;
  target_value: number;
  target_value_upper: number | null;
  time_allocation_type: TimeAllocationType | null;
  time_allocations: Record<string, number | null | { value_lower: number; value_upper: number }>;
  green_threshold_lower: number | null;
  green_threshold_upper: number | null;
  yellow_threshold_lower: number | null;
  yellow_threshold_upper: number | null;
  red_threshold_lower: number | null;
  red_threshold_upper: number | null;
  thresholds: Record<string, TransformedTargetThreshold>;
  portfolios: Relationship[];
  projects: Relationship[];
  subprojects: Relationship[];
  initiatives: Relationship[];
};

type GetAvailableTargetsResponse = Record<string, TransformedTarget[]>;

type GetAvailableTargetsPayload = {
  organization_id: string;
  portfolio_ids?: string;
  project_ids?: string;
  subproject_ids?: string;
  work_period_ids?: string;
  initiative_ids?: string;
  start_date: string;
  end_date: string;
  time_allocation_type: TimeAllocationType;
  measure?: string;
  is_work_period_target?: boolean;
};

export { TargetComparison };
export type {
  GetAvailableTargetsPayload,
  GetAvailableTargetsResponse,
  Target,
  TargetPayload,
  TransformedTarget,
  TransformedTargetThreshold,
};
